export default {
  MODEL: "QmRZ4hNBbpzq7oZBkRtHcEcpSoff4hDF3kLKR3nEyxeED3"
};
